import './tab_view.js.coffee'
Customer.Tabs ||= {}

class Customer.Tabs.TicketSummariesTabView extends Customer.Tabs.TabView
  template: JST["backbone/templates/customer/tabs/ticket_summaries_tab"]

  events:
    'click .tab': 'onClickTab'
    'click .fa-close': 'onClickClose'
    'click .fa-refresh': 'onClickUpdate'

  initialize: (@options = {}) ->
    super
    @listenTo Backbone, 'filter:collection:fetch', @closeIfFilterWasRemovedFromCollection unless @options.summary_with_ticket_id
    @listenTo(Backbone, 'update:counter', @resfreshTabAndCounter);

  resfreshTabAndCounter: (filter) ->
    @render(filter.name, filter.getCounter())

  closeIfFilterWasRemovedFromCollection: (filters) =>
    filterIDs = _.flatten(_.map(filters, (filter) =>
      if filter.get('children')
        filter.get('children').map((item) => item.id)
      else
        filter.id
      )
    )
    filterWasRemovedFromCollection = _.find(
      filterIDs,
      (id) => id == @tabbableView.selectedFilter.id
    ) == undefined
    @onClickClose() if filterWasRemovedFromCollection

  templateOptions: ->
    _.extend super, color: @tabbableView.tabColor()

  startTabRefresh: () ->
    @$el.find('.fa.fa-refresh').addClass('fa-spin')

  finishTabRefresh: () ->
    @$el.find('.fa.fa-refresh').removeClass('fa-spin')
